<template>
  <div
    class=""
    style="background-color: var(--theme-home-bg)"
    @click.stop="isNavigation = false"
  >
    <div
      class="conterTeng-scrollbar"
      ref="homeScrollbar"
      @scroll="handleScroll"
      :style="{
        height: `calc(100vh)`
      }"
    >
      <APopup :isShow="isShowAPopup" @_remove="_remove"></APopup>
      <advertisementHome
        v-if="popList.length"
        @CancelDisplay="CancelDisplay"
        :popList="popList"
        :isShow="isCancelDisplay"
      ></advertisementHome>
      <sidebars :sidebarsList="sidebarsList"> </sidebars>
      <sidebarsLeft></sidebarsLeft>
      <Header></Header>
      <Swipe :swipeList="banner"></Swipe>

      <div class="notice-bar" style="padding-left: 0.1rem !important">
        <!-- notice -->
        <div
          style="
            position: relative;
            width: 0.32rem;
            height: 0.32rem;
            color: var(--theme-text-color);
            margin-right: 0.2rem;
          "
        >
          <svg-icon
            class="svg-icon_pmd mt2"
            style="font-size: 0.32rem"
            icon-class="icon_dt_2pmd--svgSprite:all"
          />
        </div>
        <van-notice-bar class="marquee" style="height: 20px" :scrollable="true">
          <div style="display: flex; align-items: center">
            <div
              v-for="(item, index) in marquee"
              @click="openUrl('notice', { active: 3, marqueeIndex: index })"
              v-html="item"
            ></div>
          </div>
        </van-notice-bar>
        <i
          :style="`margin-left:5px;display: inline-block; position: relative; width: 0.5rem; height: 0.4375rem; background-image: url(${_coloImg}); background-position: -5.3375rem -4.275rem; background-size: 9.075rem 8.85625rem;`"
        ></i>
      </div>
      <div class="QDagHrn64BFo9TuByPWA">
        <div
          class="pFlbcXXZFoPW8cshs442"
          style="font-size: 0.2rem"
          v-if="!vuex_token_head"
        >
          <span
            class="dAp6RGRuL3x_UZPFpZC0"
            @click="
              $store.commit('isRecord'),
                $store.commit('publicFun', ['isRecordType', 1])
            "
            >{{ $t('Login._Login') }}</span
          >
          <span class="iA5Pa4sa54o0y6S_sxJr"> Ou </span>
          <span
            class="dAp6RGRuL3x_UZPFpZC0"
            @click="
              $store.commit('isRecord'),
                $store.commit('publicFun', ['isRecordType', 0])
            "
            >Cadastre-se agora</span
          >
        </div>
        <div class="" v-else>
          <div>
            <div class="FQ5QHv_dxJNHEb0Yd8h6">
              <div style="display: contents">
                <div
                  class="wPXbqIqs76_2fek3czOM vip-badge"
                  style="background: rgb(36, 178, 153)"
                >
                  <img
                    src="../../assets/icons/images/img_vip.webp"
                    class="goDRiiBsuEuXD3W1NphN GgAalyCT_nMrUn3ge8Q8 use-skeleton as4hwxmIQa3EAvA75gcx vip-img"
                  /><span :data-text="userInfo.vip_info.level">{{
                    userInfo.vip_info.level
                  }}</span>
                </div>
              </div>
              <div
                @click="copyContent(userInfo.user_name)"
                class="blXLPejbalUrq5IycYVR wJ30VxmrZK3Y5gTd1Zq0 kot86ytTGgQsl2K_lpQ5"
              >
                {{ userInfo.user_name }}
                <svg-icon
                  style="width: 0.28rem; height: 0.28rem; margin-left: 0.02rem"
                  className="imageWrap"
                  icon-class="style_1_icon_copy--svgSprite:all"
                />
              </div>
            </div>
          </div>
          <div style="display: flex">
            <div
              class="vy918omw_N7rBkJ235XX"
              style="--row-align: center; --mode: flex; --column-align: center"
            >
              <div
                class="lop_top"
                :style="{
                  backgroundImage: `url(${img_hb_frame})`
                }"
                style="background-position: 0px 0px; background-size: 100% 100%"
              >
                <i
                  class="yj5rHjAv0U7RlHMzWr7F img skeleton-box"
                  :style="{
                    backgroundImage: `url(${_coloImg})`
                  }"
                  style="
                    display: inline-block;
                    position: relative;
                    width: 0.3rem;
                    height: 0.3rem;
                    background-position: -7.15714rem -2.79643rem;
                    background-size: 7.77857rem 7.59107rem;
                  "
                ></i>
              </div>
              <section class="_top_currency-count" style="font-size: 0.18rem">
                <div class="countTextBox" @click="animate">
                  <span class="SSAbrhtT3U690CrzLUd5 count-to">
                    <span class="notranslate">{{ userBalance }}</span>
                  </span>
                  <svg-icon icon-class="comm_icon_sx--svgSprite:all" />
                </div>
              </section>
            </div>
          </div>
        </div>

        <div class="DrSAta3RAIhChb6OSZTc">
          <div
            class="nGxwk_oNvWwlxdYhmaMt"
            @click="$router.push({ name: 'promote' })"
          >
            <i
              :style="{
                backgroundImage: `url(${_coloImg3Dian5})`
              }"
              style="
                display: inline-block;
                position: relative;
                width: 0.54rem;
                height: 0.5rem;
                background-position: 8rem 17.4rem;
                background-size: 6.2057692307692305rem 5.4788461538461535rem;
              "
            />
            <div class="R6JnJ5r1Gimo5SZaqJCu">
              {{ $t('toolbarConter._Agente') }}
            </div>
          </div>
          <div
            class="nGxwk_oNvWwlxdYhmaMt"
            @click="$router.push({ name: 'vip' })"
          >
            <i
              :style="{
                backgroundImage: `url(${_coloImg3Dian5})`
              }"
              style="
                display: inline-block;
                position: relative;
                width: 0.54rem;
                height: 0.5rem;
                background-position: 7.16rem 9.05rem;
                background-size: 6.2057692307692305rem 5.4788461538461535rem;
              "
            />
            <div class="R6JnJ5r1Gimo5SZaqJCu">VIP</div>
          </div>
          <div
            class="nGxwk_oNvWwlxdYhmaMt"
            @click.stop="$store.commit('publicFun', ['AppDownload', true])"
          >
            <i
              :style="{
                backgroundImage: `url(${_coloImg3Dian5})`
              }"
              style="
                display: inline-block;
                position: relative;
                width: 0.54rem;
                height: 0.5rem;
                background-position: 7.7rem 5.04rem;
                background-size: 6.2057692307692305rem 5.4788461538461535rem;
              "
            />
            <div class="R6JnJ5r1Gimo5SZaqJCu">{{ $t('popup._BaixarApp') }}</div>
          </div>
          <div
            class="nGxwk_oNvWwlxdYhmaMt"
            @click.stop="isNavigation = !isNavigation"
          >
            <i
              :style="{
                backgroundImage: `url(${_coloImg3Dian5})`
              }"
              style="
                display: inline-block;
                position: relative;
                width: 0.54rem;
                height: 0.5rem;
                background-position: 7.7rem 13.05rem;
                background-size: 6.2057692307692305rem 5.4788461538461535rem;
              "
            />
            <div class="R6JnJ5r1Gimo5SZaqJCu">{{ $t('_home._Mais') }}</div>
          </div>
          <navigation
            @ChesngAPopup="_remove"
            :isNavigation="isNavigation"
          ></navigation>
        </div>
      </div>
      <div
        class="tabs conter_box conter_box-2"
        :class="{
          isTabsShow: isTabsShow
        }"
      >
        <van-tabs
          v-model="$store.state.active"
          @change="tabFun"
          ref="navTbaSwConte"
          @disabled="onClickDisabled"
          scrollspy
          sticky
          :offset-top="`${$store.state.xiazApp ? 0.9 + 0.7 : 0.9}rem`"
          @scroll="scrollTabs"
        >
          <div
            style="
              --jackpot-card-count-box-scale: 0.66;
              --jackpot-card-count-box-height: 0.76rem;
              --jackpot-card-count-to-bottom: 0.245rem;
              --jackpot-card-width: 100%;
              --jackpot-card-height: 1.64rem;
              --jackpot-font-letter-spacing: 0.007rem;
              --jackpot-card-margin: 0 0 0.2rem;
              --jackpot-font-color: var(--theme-text-color);
              --jackpot-font-size: 0.48rem;
            "
            class="Ks5gwBkzEwTSEHtNE2PQ"
          >
            <!-- https://cdntoos.vr6pg.com/cocos/icon/vjp/1825238600611532802.png -->
            <div
              class="_VQdc8vOEOzzyOEUKmvZ"
              :style="`background-image: url(${config.jackpot_image});background-size: 100% 100%;background-position: 0 0;`"
            >
              <CountTo
                :startVal="startVal"
                @getDisplayValue="getDisplayValue"
                :endVal="BonusAmount"
                :decimals="2"
                :duration="5000"
              />
              <div
                slot="defaultValue"
                class="defaultValue"
                style="
                  margin-top: 0.3rem;
                  display: flex;
                  align-items: center;
                  --jackpot-card-count-box-scale: 0.6;
                  transform: scale(var(--jackpot-card-count-box-scale));
                "
              >
                <p
                  v-for="(item, index) in BonusTrendsAmount"
                  style="display: flex; height: 0.83rem"
                >
                  <i
                    v-if="item == ','"
                    :style="{
                      display: 'inline-block',
                      width: '0.22rem',
                      height: '0.72rem',
                      backgroundImage: `url(${_coloImg_se})`,
                      backgroundPosition: `-4.62rem 0`,
                      backgroundSize: '8.36rem .72rem'
                    }"
                  ></i>
                  <i
                    v-else-if="item == '.'"
                    :style="{
                      display: 'inline-block',
                      width: '0.22rem',
                      height: '0.72rem',
                      backgroundImage: `url(${_coloImg_se})`,
                      backgroundPosition: `-4.4rem 0rem`,
                      backgroundSize: '8.36rem .72rem'
                    }"
                  ></i>
                  <i
                    v-else
                    :style="{
                      display: 'inline-block',
                      width: '0.44rem',
                      height: '0.72rem',
                      backgroundImage: `url(${_coloImg_se})`,
                      backgroundPosition: `${'-' + item * 0.44}rem 0rem`,
                      backgroundSize: '8.36rem .72rem'
                    }"
                  ></i>
                </p>
              </div>
            </div>
          </div>
          <van-tab v-for="(item, index) in iconList" :key="index" :name="index">
            <div
              class="h5MidMenuTabTitle h5MidMenuActive"
              slot="title"
              @click="subgame('', item.name == 'slots' ? 'popular' : '')"
            >
              <div class="imageWrap">
                <svg-icon
                  v-if="$store.state.active != index"
                  style="width: 0.55rem !important; height: 0.55rem !important"
                  className="imageWrap"
                  :icon-class="item.svg"
                />
                <img
                  v-else
                  class="goDRiiBsuEuXD3W1NphN GgAalyCT_nMrUn3ge8Q8 use-skeleton _S3Gqs7Pat3lw5JdNOCd navIcon navIconUrl"
                  :src="activeList[index]"
                  alt=""
                />
              </div>
              <!-- <svg-icon v-if="$store.state.active!=index" className="imageWrap" :icon-class="item.svg" /> -->

              <span
                class="TMZWYZcIv5YQXVdFMVrw inner-text"
                style="
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  display: -webkit-box;
                  line-height: 1.2;
                  overflow: hidden;
                  overflow: initial;
                  text-align: center;
                  text-overflow: ellipsis;
                  vertical-align: middle;
                  word-break: break-word;
                "
              >
                {{ $t('popup')[item.textName] }}
              </span>
            </div>

            <!-- <div></div> -->
            <div
              class="vwuYKuCNAmUF0GsyJhVu"
              style="overflow: hidden"
              v-if="item.name == 'popular' && $store.state.active < 2"
            >
              <div style="height: 0.34rem"></div>
              <div
                class="gameItemBox"
                style="
                  width: 7.4rem;
                  --cardRowSpacing: 0.22rem;
                  --cardColSpacing: 0.075rem;
                  margin: -0.22rem -0.075rem;
                "
              >
                <gameItem
                  v-for="(item_a, index_1) in tabNav[item.name].list"
                  :category="item.name"
                  :item="item_a"
                  type="home"
                  :key="index_1"
                ></gameItem>
                <div
                  style="display: flex; justify-content: center; width: 100%"
                >
                  <van-empty
                    v-if="!tabNav[item.name].list.length"
                    image-size="106px"
                    class="custom-image"
                    :image="img_none_sj"
                    :description="$t('_Nenhumjogodisponvel')"
                  />
                </div>
              </div>
            </div>

            <div
              class="vwuYKuCNAmUF0GsyJhVu"
              style="overflow: hidden"
              v-if="item.name == 'slots' && $store.state.active < 2"
              v-for="(platform, index_platform) in slots"
              :key="index_platform"
            >
              <div
                class="kQtvRRirB33JTKwlSb26 titleWrap"
                style="border-top: 0.01rem solid var(--theme-color-line)"
              >
                <div class="leftTitle">
                  <img
                    class="imageWrap"
                    style="margin-right: 0.13rem; height: 100% !important"
                    :src="platform.img"
                    alt=""
                  />
                  {{ platform.name }}
                </div>
                <!-- category=slot -->
                <div class="rightTitle" @click="subgame(platform.key)">
                  Tudo
                </div>
              </div>
              <div
                class="gameItemBox"
                style="
                  width: 7.4rem;
                  --cardRowSpacing: 0.22rem;
                  --cardColSpacing: 0.075rem;
                  margin: -0.22rem -0.075rem;
                "
              >
                <gameItem
                  v-for="(item_a, index_1) in tabNav[platform.key].list"
                  :item="item_a"
                  type="home"
                  :key="index_1"
                ></gameItem>
                <div
                  style="display: flex; justify-content: center; width: 100%"
                >
                  <van-empty
                    v-if="!tabNav[platform.key].list.length"
                    image-size="106px"
                    class="custom-image"
                    :image="img_none_sj"
                    :description="$t('_Nenhumjogodisponvel')"
                  />
                </div>
              </div>
              <div
                class="bkAYznjEc9hUqGQh_a3S scroll-down"
                @click="congxJiazai(platform.key)"
                style="margin-top: 0.35rem"
                v-if="tabNav[platform.key].now < tabNav[platform.key].count"
              >
                {{ $t('_home._Aexibir') }} {{ tabNav[platform.key].now }}
                {{ $t('_home._jogosentre') }}
                {{ tabNav[platform.key].count }}&nbsp;{{ platform.name
                }}{{ $t('_home._Popularjogos') }}
                <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
                  {{ $t('_home._Carregarmais') }}
                  <svg-icon
                    className="imageWrap_s"
                    style="
                      width: 0.14rem;
                      height: 0.14rem;
                      vertical-align: unset;
                    "
                    icon-class="comm_icon_jzgd--svgSprite:all"
                  />
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>

        <div
          class="vwuYKuCNAmUF0GsyJhVu"
          v-if="iconList[$store.state.active].textName == '_Recente'"
        >
          <div class="kQtvRRirB33JTKwlSb26 titleWrap">
            <div class="leftTitle">
              <img
                class="imageWrap"
                style="margin-right: 0.07rem"
                :src="activeList[$store.state.active]"
                alt=""
              />
              {{ $t('popup.nav')[4].title }}
            </div>
          </div>
          <div class="gameItemBox">
            <gameItem
              v-for="(item_a, index_1) in recentJson.list"
              :item="item_a"
              type="home"
              :key="index_1"
            ></gameItem>
            <div style="display: flex; justify-content: center; width: 100%">
              <van-empty
                v-if="!recentJson.list.length"
                image-size="106px"
                class="custom-image"
                :image="img_none_sj"
                :description="$t('_Nenhumjogodisponvel')"
              />
            </div>
          </div>
          <div
            class="bkAYznjEc9hUqGQh_a3S scroll-down"
            @click="congxJiazai(iconList[$store.state.active].name)"
            v-if="recentJson.now < recentJson.count"
          >
            {{ $t('_home._Aexibir') }} {{ recentJson.now }}
            {{ $t('_home._jogosentre') }} {{ recentJson.count }}&nbsp;{{
              $t('_home._Popularjogos')
            }}
            <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
              {{ $t('_home._Carregarmais') }}
              <svg-icon
                className="imageWrap_s"
                style="width: 0.14rem; height: 0.14rem; vertical-align: unset"
                icon-class="comm_icon_jzgd--svgSprite:all"
              />
            </div>
          </div>
        </div>
        <div
          class="vwuYKuCNAmUF0GsyJhVu"
          v-if="iconList[$store.state.active].textName == '_Favoritos'"
        >
          <div class="kQtvRRirB33JTKwlSb26 titleWrap">
            <div class="leftTitle">
              <img
                class="imageWrap"
                style="margin-right: 0.07rem"
                :src="activeList[$store.state.active]"
                alt=""
              />
              {{ $t('popup.nav')[5].title }}
            </div>
          </div>
          <div class="gameItemBox">
            <gameItem
              v-for="(item_a, index_1) in favoriteJson.list"
              :item="item_a"
              type="home"
              :key="index_1"
            ></gameItem>
            <div style="display: flex; justify-content: center; width: 100%">
              <van-empty
                v-if="!favoriteJson.list.length"
                image-size="106px"
                class="custom-image"
                :image="img_none_sj"
                :description="$t('_Nenhumjogodisponvel')"
              />
            </div>
          </div>
          <div
            class="bkAYznjEc9hUqGQh_a3S scroll-down"
            @click="congxJiazai(iconList[$store.state.active].name)"
            v-if="favoriteJson.now < favoriteJson.count"
          >
            {{ $t('_home._Aexibir') }} {{ favoriteJson.now }}
            {{ $t('_home._jogosentre') }} {{ favoriteJson.count }}&nbsp;{{
              $t('_home._Popularjogos')
            }}
            <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
              {{ $t('_home._Carregarmais') }}
              <svg-icon
                className="imageWrap_s"
                style="width: 0.14rem; height: 0.14rem; vertical-align: unset"
                icon-class="comm_icon_jzgd--svgSprite:all"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header/index.vue';
// @ is an alias to /src
import Sidebar from '@/components/sidebar/index.vue';
import Swipe from '@/components/swipe/index.vue';
import {
  ICON_NAV,
  ICON_NAV3Dian4,
  ICON_NAVActive,
  ICON_NAV3Dian4Active
} from '@/assets/public/icon_nav.js';
import Overlay from '@/components/audio/overlay.vue';
import gameItem from '@/components/gameItem/index.vue';

import CountTo from '@/components/vue-count-to/vue-countTo.vue';
import advertisementHome from '@/components/advertisement/home.vue';
import navigation from './four/navigation.vue';
import Footer from './four/footer.vue';
import sidebars from '@/components/sidebars/index3.5.vue';
import APopup from '@/components/Idioma-popup/index.vue';
import sidebarsLeft from '@/components/sidebars/index-left.vue';
import { mapState } from 'vuex';
let time;
import Vue from 'vue';
import {
  baseConfig,
  popAndBanner,
  notification,
  jackpot,
  getAllGameCategory,
  getDataByGameCategory
} from '@/apis/modules/home.js';
export default {
  name: 'Home',
  components: {
    sidebarsLeft,
    Sidebar,
    Swipe,
    Overlay,
    sidebars,
    CountTo,
    gameItem,
    advertisementHome,
    Header,
    Footer,
    navigation,
    APopup
  },
  computed: {
    ...mapState([
      'popList',
      'tabNav',
      'first_recharge',
      'banner',
      'moneyInfo',
      'sidebarsList',
      'marquee',
      'config',
      'vuex_token_head',
      'userInfo',
      'isCancelDisplay'
    ])
  },
  data() {
    return {
      tongzhi: require('./../../assets/icons/images/icon_dt_pmd.png'),
      coloImgactivity: require('./../../assets/icons/images/1795312712372871170.gif'),
      img_hb_frame: require('./../../assets/icons/images/img_hb_frame.webp'),
      startVal: 0,
      iconList: [],
      isNavigation: false,
      widUrl: window.location.href,
      activeList: ICON_NAV3Dian4Active,
      base_Config: {},
      BonusAmount: '',
      BonusTrendsAmount: '',
      recentJson: {},
      favoriteJson: {},
      thisiTime: '',
      tabState: false,
      vuex_tokenIs: false,
      scrollDom: '',
      isTabsShow: false,
      tabForm: {
        leftRight: 0
      },
      isShowAPopup: false,
      userBalance: '0,00',
      slots: {
        pg: {
          name: 'PG',
          key: 'pg',
          img: require('./../../assets/icons/active/pg.png')
        },
        pp: {
          name: 'Pragmatic Play',
          key: 'pp',
          img: require('./../../assets/icons/active/pp.png')
        },
        jili: {
          name: 'JILI',
          key: 'jili',
          img: require('./../../assets/icons/active/jili.png')
        },
        jdb: {
          name: 'JDB',
          key: 'jdb',
          img: require('./../../assets/icons/active/jdb.png')
        }
      }
    };
  },
  created() {
    this.inviteFun();
    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.getBalance();
      this.vuex_tokenIs = true;
    }
    this.iconList = ICON_NAV3Dian4;
    let inviteTime = localStorage.getItem('inviteTime');
    if (inviteTime && this.popList.length) {
      if (inviteTime > new Date().getTime()) {
        this.$store.commit('publicFun', ['isCancelDisplay', false]);
      } else {
        this.$store.commit('publicFun', ['isCancelDisplay', true]);
      }
    }
    // console.log(inviteTime,new Date().getTime())
    // console.log(inviteTime>new Date().getTime())
    this.getpopAndBanner();
    this.getNotification();
    this.getAllGameCategory();
    this.showRegisterPage();
    this.showBalance();
  },
  mounted() {
    Vue.prototype.homeScrollbarDom = this.$refs.homeScrollbar;
    this.$nextTick(() => {
      let el = this.$refs.navTbaSwConte.$el;
      let scrollDom = el.getElementsByClassName('van-tabs__nav--complete')[0];
      this.scrollDom = scrollDom;
      let offsetWidth = scrollDom.offsetWidth;
      let scrollWidth = scrollDom.scrollWidth;
      let scrollJisuan = scrollWidth - offsetWidth;
      let { leftRight } = this.tabForm;
      scrollDom.addEventListener('scroll', e => {
        if (scrollJisuan <= scrollDom.scrollLeft) {
          this.tabForm.leftRight = 1;
        } else if (scrollDom.scrollLeft == 0) {
          this.tabForm.leftRight = 0;
        } else if (leftRight != 2 && scrollDom.scrollLeft != 0) {
          this.tabForm.leftRight = 2;
        }
      });
    });
    this.getjackpot(0);
  },
  beforeDestroy() {
    clearTimeout(this.thisiTime);
  },
  watch: {
    moneyInfo: {
      handler(val) {
        this.showBalance();
      },
      deep: true
    }
  },
  methods: {
    _remove(e) {
      this.isShowAPopup = !this.isShowAPopup;
    },
    showBalance() {
      this.userBalance = this.$store.state.config.balance_no_bonus.includes(
        'home'
      )
        ? this.moneyInfo.balance_coin_str
        : this.moneyInfo.balance_total_str;
    },
    CancelDisplay(e) {
      this.$store.commit('publicFun', ['isCancelDisplay', false]);
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let isRechargeGiftTime = localStorage.getItem('isRechargeGiftTime');
          let isRechargeGift = localStorage.getItem('isRechargeGift');
          if (isRechargeGiftTime && isRechargeGift !== 'false') {
            if (isRechargeGiftTime < new Date().getTime()) {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
          }
          if (!isRechargeGift && !isRechargeGiftTime) {
            if (this.first_recharge.status == 'show') {
              this.$store.commit('publicFun', ['isRechargeGift', true]);
            }
          }
        }, 500);
        this.$store.commit('publicFun', ['isRefreshLoading', false]);
      }
    },
    showRegisterPage() {
      if (this.vuex_tokenIs || !this.$store.state.config.register_page_pop)
        return;
      this.$store.commit('isRecord');
      this.$store.commit('publicFun', ['isRecordType', 0]);
    },
    inviteFun() {
      let { id, invite_code, type } = this.$route.query;
      //console.log(this.$route.query,id,type,'inviteID 22')
      let inviteCode = id || invite_code;
      if (inviteCode > 1000000) {
        window.localStorage.setItem('inviteID', inviteCode);
      }
      // this.$store.commit('isRecord')
      // this.$store.commit('publicFun',['isRecordType',0])
    },
    navTbaSw(e) {
      if (e == 'right') {
        this.scrollDom.scrollLeft = 1000;
      }
      if (e == 'left') {
        this.scrollDom.scrollLeft = 0;
      }
    },
    beforeChange(name, title) {
      //
    },
    scrollTabs(e) {},
    handleScroll(e) {
      clearTimeout(time);
      time = setTimeout(() => {
        clearTimeout(time);
        if (e.target.scrollTop > e.target.offsetHeight / 3 + 59) {
          this.$store.commit('publicFun', ['Returntotop', true]);
        } else if (this.$store.state.Returntotop) {
          this.$store.commit('publicFun', ['Returntotop', false]);
        }
        if (
          e.target.scrollTop >
          e.target.scrollHeight - e.target.offsetHeight - 20
        ) {
          this.isTabsShow = true;
        } else {
          this.isTabsShow = false;
        }
      }, 10);
    },
    isDisabled(index) {
      let isTrue = false;
      let active = this.$store.state.active;
      if (index == 3) {
        isTrue = true;
        return true;
      }
      if (active < 3) {
        if (index < 3) {
          return false;
        }
        if (index > 3) {
          isTrue = false;
          return true;
        }
      }
      if (active > 3) {
        if (index < 3) {
          isTrue = true;
          return true;
        }
        if (index > 3) {
          isTrue = false;
          return false;
        }
      }
      return isTrue;
    },
    getAllGameCategory() {
      if (this.tabNav.popular) {
        return false;
      }
      getAllGameCategory({}).then(({ code, data = {}, msg }) => {
        this.$store.commit('publicFun', ['tabNav', data]);
      });
    },
    goToNewPage(url) {
      if (url == '#') {
        return false;
      }
      window.open(url, '_blank');
    },
    congxJiazai(category, _key_) {
      //console.log(category,_key_,'xxxxx');
      let pageSize = this.$store.state.config.popular_page_size
        ? this.$store.state.config.popular_page_size
        : 6;
      let page = this.tabNav[category]
        ? this.tabNav[category].now / pageSize + 1
        : 1;
      if (_key_) {
        page = this[_key_ + 'Json'].now
          ? this[_key_ + 'Json'].now / pageSize + 1
          : 1;
      }
      getDataByGameCategory({
        category: category,
        page: page
      }).then(({ code, data = {}, msg }) => {
        if (!_key_) {
          this.tabNav[category] = {
            ...this.tabNav[category],
            now: data.now,
            list: [...this.tabNav[category].list, ...data.list]
          };
          this.$store.commit('publicFun', ['tabNav', this.tabNav]);
        } else {
          let listz = this[_key_ + 'Json'].list
            ? [...this[_key_ + 'Json'].list, ...data.list]
            : [...data.list];
          this[_key_ + 'Json'] = {
            ...this[_key_ + 'Json'],
            now: data.now,
            list: listz
          };
        }
      });
    },
    getDisplayValue(value) {
      this.BonusTrendsAmount = value;
    },
    getpopAndBanner() {
      //
      if (this.banner.length) {
        return false;
      }
      popAndBanner({}).then(({ code, data = {}, msg }) => {
        let { banner, pop, sidebars, first_recharge } = data;
        this.$store.commit('publicFun', ['banner', banner]);
        this.$store.commit('publicFun', ['first_recharge', first_recharge]);
        // this.banner = banner;
        if (!this.popList.length) {
          this.$store.commit(
            'popList',
            pop.map(item => {
              return {
                ...item,
                isShow: true
              };
            })
          );
        }
        this.$store.commit('publicFun', [
          'sidebarsList',
          sidebars.map(item => {
            return {
              ...item,
              isShow: true
            };
          })
        ]);
      });
    },

    getNotification() {
      if (this.marquee) {
        return false;
      }
      notification({}).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
        this.$store.commit('publicFun', ['marquee', marquee]);
      });
    },
    getjackpot(tim, _false) {
      if (!this.$store.state.config.show_jackpot) return;
      // if(_false){return false}
      clearTimeout(this.thisiTime);
      this.thisiTime = setTimeout(() => {
        jackpot({
          isLOgin: true
        }).then(({ code, data, msg }) => {
          this.startVal = data - 1999 || 0;
          this.BonusAmount = data || 0;
        });
        if (this.$route.name == 'home') {
          this.getjackpot(10000);
        }
        let { code, category } = this.$route.query;
      }, tim);
    },
    subgame(code, platform = null) {
      if (!code && !platform) return;
      this.$router.push({
        name: 'subgame',
        query: {
          category: 'slot',
          code: code,
          platformValue: platform
        }
      });
      // piscator
    },
    onClickDisabled(e) {
      this.$router.push({
        name: 'subgame',
        query: {
          id: '',
          category: 'demo'
        }
      });
    },
    tabFun(e, title) {
      let category = this.iconList[e].name;
      if (category == 'recent') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      if (category == 'favorite') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      //
      // console.log(name,title)
      // if(e==4){
      //  this.onClickDisabled()
      // }
      this.$store.commit('active', e);
    },
    stickyScroLL(e) {}
  }
};
</script>
<style>
.tabs.conter_box-2 {
  height: auto;
}

.tabs.conter_box-2 .van-tabs .van-tabs__nav {
  background-color: var(--theme-home-bg);
  border-bottom: 0.01rem solid var(--theme-color-line);
  height: 0.94rem;
  padding: 0.08rem 0 0;
  width: var(--theme-max-width);
  max-width: calc(100vw);
}

.tabs.conter_box-2 .van-tabs__wrap--scrollable .van-tab {
  padding: 0;
  display: flex;
}

.tabs.conter_box-2 .h5MidMenuTab {
  display: flex;
  height: 100%;
  padding: 0 4px;
  box-sizing: border-box;
  background-color: var(--theme-home-bg);
}

.tabs.conter_box-2 .imageWrap {
  font-size: 0.54rem;
  height: 0.48rem !important;
  display: flex;
  align-items: center;
  /* margin-right: .16rem; */
  width: 0.64rem !important;
}

.tabs.conter_box-2 .van-tabs__line {
  min-width: 1rem;
}

.tabs.conter_box-2 .van-tabs__wrap--scrollable .van-tabs__nav {
  overflow: initial;
  display: flex;
}

.tabs.conter_box-2 .game-category-name {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  line-height: 1.2;
  overflow: hidden;
  overflow: initial;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  word-break: break-word;
  /* width: .6rem !important; */
  max-width: initial;
}

.tabs.conter_box-2 .van-tabs__wrap--scrollable .van-tab {
  flex: revert-layer;
}

.tabs.conter_box-2 .gameItemBox {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100%;
}

.tabs.conter_box-2 .vwuYKuCNAmUF0GsyJhVu {
}

.a {
  background-color: var(--theme-home-bg);
  height: 0.94rem;
  padding: 0.08rem 0 0;
}
</style>
<style scoped>
.vwuYKuCNAmUF0GsyJhVu {
  padding: 0.2rem 0.2rem;
}

.titleWrap {
  width: 100%;
}
.titleWrap .rightTitle {
  margin: -0.12rem -0.2rem;
  padding: 0.12rem 0.2rem;
  color: var(--theme-text-color-lighten);
  cursor: pointer;
  font-size: 0.24rem;
}
.blXLPejbalUrq5IycYVR {
  color: var(--theme-text-color-darken);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  font-weight: 300;
  align-items: center;
  margin-left: 0.1rem;
}
.FQ5QHv_dxJNHEb0Yd8h6 {
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
  font-size: 0.22rem;
}
.FQ5QHv_dxJNHEb0Yd8h6 .wPXbqIqs76_2fek3czOM {
  border-radius: 0.04rem;
  height: 0.22rem;
  max-width: 0.62rem;
  min-width: 0.56rem;
  box-sizing: border-box;
  padding: 0 0.04rem 0 0.05rem;
}
.wPXbqIqs76_2fek3czOM {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  border-radius: 0.04rem 0 0.04rem 0;
  display: -ms-flexbox;
  display: flex;
  height: 0.12rem;
  justify-content: center;
  max-width: 0.33rem;
  min-width: 0.29rem;
}
.FQ5QHv_dxJNHEb0Yd8h6 .vip-img {
  border-radius: 0;
  border-radius: initial;
  min-width: 0 !important;
  min-width: auto !important;
  width: 0.276rem;
}
.wPXbqIqs76_2fek3czOM span:before {
  -webkit-background-clip: text;
  background-clip: text;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#f7ea94),
    color-stop(51%, #e5b952),
    to(#ce9510)
  );
  background-image: linear-gradient(180deg, #f7ea94 0, #e5b952 51%, #ce9510);
  background-size: cover;
  content: attr(data-text);
  height: 100%;
  left: 0;
  position: absolute;
  text-shadow: none;
  top: 0;
  width: 100%;
  z-index: 0;
}
.wPXbqIqs76_2fek3czOM span {
  color: transparent;
  display: inline-block;
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 700;
  margin: -0.02rem 0 0;
  position: relative;
  text-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.4);
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

.FQ5QHv_dxJNHEb0Yd8h6 span {
  background: transparent none repeat 0 0 / auto auto padding-box border-box
    scroll;
  background: initial;
  font-size: 0.28rem;
  font-style: italic;
  margin-top: -0.025rem;
}

.vy918omw_N7rBkJ235XX {
  height: 0.4rem;
  padding: 0 0.084rem 0 0.02rem;
  border: thin solid var(--theme-color-line);
  border-radius: 0.2rem;
  -ms-flex-align: var(--column-align);
  -ms-flex-pack: var(--row-align);
  align-items: var(--column-align);
  display: var(--mode);
  height: 0.4rem;
  justify-content: var(--row-align);
  line-height: normal;
  padding: 0 0.05rem 0 0.02rem;
  position: relative;
  width: auto;
}

.lop_top {
  width: 0.34rem;
  height: 0.34rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

._top_currency-count .notranslate {
  color: var(--theme-secondary-color-finance);
  font-size: 0.26rem;
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏超出容器的文本 */
  text-overflow: ellipsis;
  /* 在文本末尾添加省略号 */
  max-width: 1.2rem;
  display: inline-block;
  border-bottom: 0.02rem solid var(--theme-secondary-color-finance);
}

._top_currency-count .countTextBox {
  display: flex;
  align-items: center;
}

._top_currency-count .svg-icon {
  color: var(--theme-alt-primary);
  font-size: 0.293rem;
  width: 0.293rem;
  height: 0.293rem;
  z-index: 10;
}

._top_currency-count .SSAbrhtT3U690CrzLUd5 {
  display: block;
  margin: 0 0.073rem 0 0.1rem;
  max-width: 1.64rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Ks5gwBkzEwTSEHtNE2PQ {
  margin: 0.2rem 0.2rem -0.1rem;
}

._VQdc8vOEOzzyOEUKmvZ {
  cursor: pointer;
  height: var(--jackpot-card-height);
  margin: var(--jackpot-card-margin);
  position: relative;
  width: var(--jackpot-card-width);
}

.defaultValue {
  justify-content: center;
}

.marquee {
  background-color: rgba(0, 0, 0, 0) !important;
}

.QDagHrn64BFo9TuByPWA {
  padding: 0 0.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dAp6RGRuL3x_UZPFpZC0 {
  color: var(--theme-primary-color);
  cursor: pointer;
}

.iA5Pa4sa54o0y6S_sxJr {
  color: var(--theme-text-color);
}

.DrSAta3RAIhChb6OSZTc {
  display: flex;
  position: relative;
  flex-wrap: wrap;
}

.nGxwk_oNvWwlxdYhmaMt {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-right: 0.05rem;
  max-width: 1rem;
  min-width: 0.9rem;
  position: relative;
}

.R6JnJ5r1Gimo5SZaqJCu {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--theme-text-color);
  display: -webkit-box;
  font-size: 0.2rem;
  line-height: 1.1;
  margin-top: 0.062rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 1rem;
}

.h5MidMenuTabTitle {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-lighten);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.24rem;
  height: 0.94rem;
}

.h5MidMenuTabTitle .imageWrap {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  -ms-flex: none;
  flex: none;
  min-height: 0.4rem;
  width: 0.64rem;
}

.N4LsWhJBhqqyTkv6V0NE {
  display: inline-block;
  line-height: 0;
  overflow: hidden;
}

.h5MidMenuTabTitle .navIcon {
  font-size: 0.54rem;
  height: 0.48rem;
  margin-right: 0.16rem;
  width: 0.64rem;
}
.svg-icon {
  width: 0.32rem;
  height: 0.32rem;
}
.svg-icon_pmd {
  position: absolute;
  left: 0;
}
</style>
